const constants = {
  SCENARIOS_LOAD_START: 'SCENARIOS_LOAD_START',
  SCENARIOS_LOAD_END: 'SCENARIOS_LOAD_END',
  SCENARIOS_FETCH_START: 'SCENARIOS_FETCH_START',
  SCENARIOS_FETCH_END: 'SCENARIOS_FETCH_END',
  SCENARIOS_FETCH_REPOS_START: 'SCENARIOS_FETCH_REPOS_START',
  SCENARIOS_FETCH_REPOS_END: 'SCENARIOS_FETCH_REPOS_END',
  SCENARIOS_FETCH_REPO_START: 'SCENARIOS_FETCH_REPO_START',
  SCENARIOS_FETCH_REPO_END: 'SCENARIOS_FETCH_REPO_END',
  SCENARIOS_CHANGE_MODAL_STATE: 'SCENARIOS_CHANGE_MODAL_STATE',
  SCENARIOS_SELECT: 'SCENARIOS_SELECT',
  SCENARIOS_SELECT_REPO_SIM: 'SCENARIOS_SELECT_REPO_SIM',
  SCENARIOS_SELECT_REPO: 'SCENARIOS_SELECT_REPO',
  SCENARIOS_DOWNLOAD_START: 'SCENARIO_DOWNLOAD_START',
  SCENARIOS_DOWNLOAD_END: 'SCENARIO_DOWNLOAD_END',
  SCENARIOS_DELETE_START: 'SCENARIO_DELETE_START',
  SCENARIOS_DELETE_END: 'SCENARIO_DELETE_END',
  SCENARIOS_UPLOAD_START: 'SCENARIOS_UPLOAD_START',
  SCENARIOS_UPLOAD_END: 'SCENARIOS_UPLOAD_END',
  SCENARIOS_SET_UPDATE_FLAG: 'SCENARIOS_SET_UPDATE_FLAG',
  SCENARIOS_SET_ERROR_MESSAGE: 'SCENARIOS_SET_ERROR_MESSAGE',
  SCENARIOS_CLOSE_ERROR: 'SCENARIOS_CLOSE_ERROR',
  SCENARIOS_CLEAR_ERROR: 'SCENARIOS_CLEAR_ERROR',
  SCENARIOS_CHANGE_FILTER: 'SCENARIOS_CHANGE_FILTER',
  SCENARIOS_RESET_FILTER: 'SCENARIO_RESET_FILTER',
  SCENARIOS_MAPEDITOR_TOGGLE: 'SCENARIOS_MAPEDITOR_TOGGLE',
};

export default constants;
